module.exports = __webpack_public_path__ + "4de427a8b7c5b4339acb18045126ab7e.ttf";